module.exports = __webpack_public_path__ + "img/top.34175d75.jpg";